import { createSelector } from 'reselect';
import { areOrderItemsFetching, hasOrderItemsFetchingFailed } from '../reservationModuleState';
import { areResourcesFetching, haveResourcesFailed } from './resources';
import { areReservationsFetching, haveReservationsFailed } from './reservations';

export const isReservationOverviewInitializing = createSelector(
    areResourcesFetching,
    areReservationsFetching,
    areOrderItemsFetching,
    (resourcesFetching, reservationsFetching, orderItemsFetching) =>
        resourcesFetching || reservationsFetching || orderItemsFetching
);

export const hasReservationOverviewInitializingFailed = createSelector(
    haveResourcesFailed,
    haveReservationsFailed,
    hasOrderItemsFetchingFailed,
    (resourcesFailed, reservationsFailed, orderItemsFailed) => resourcesFailed || reservationsFailed || orderItemsFailed
);

export { isSpaceDialogOpen } from './spaceDialog';
